export default "__VITE_ASSET__BGQW5VhB__"